module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "SQL Workbench",
      "active": ""
    }
  })], 1), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-button-toolbar', {
    staticClass: "pb-2",
    attrs: {
      "key-nav": "",
      "aria-label": "Toolbar with button groups"
    }
  }, [_c('b-button-group', {
    staticClass: "mx-1"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.query === '',
      "title": "Execute query"
    },
    on: {
      "click": function($event) {
        return _vm.onExecuteQuery()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "play"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.query === '',
      "title": "Execute count query"
    },
    on: {
      "click": function($event) {
        return _vm.onCountQuery()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "calculator"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "disabled": _vm.query === '',
      "title": "Prettify SQL"
    },
    on: {
      "click": function($event) {
        return _vm.prettify()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "align-left"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Clear editor"
    },
    on: {
      "click": function($event) {
        return _vm.onClear()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "eraser"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Close all tabs"
    },
    on: {
      "click": function($event) {
        _vm.tabs = []
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "times"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button-group', {
    staticClass: "mx-1"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Sync catalog"
    },
    on: {
      "click": function($event) {
        return _vm.syncCatalog()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "sync"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Show catalog"
    },
    on: {
      "click": function($event) {
        return _vm.onToggleCatalogTree()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "database"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Show saved queries"
    },
    on: {
      "click": function($event) {
        return _vm.onToggleSavedQueries()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "file-alt"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-primary",
      "title": "Switch editors"
    },
    on: {
      "click": function($event) {
        return _vm.onToggleEditor()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "edit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('splitpanes', {
    staticClass: "splitpanes",
    staticStyle: {
      "height": "750px"
    },
    on: {
      "resize": function($event) {
        _vm.preferences.catalogPaneSize = $event[0].size
      }
    }
  }, [(_vm.preferences.showCatalogTree) ? _c('pane', {
    staticClass: "p-2",
    staticStyle: {
      "display": "block",
      "overflow": "auto"
    },
    attrs: {
      "size": _vm.preferences.catalogPaneSize
    }
  }, [_c('a-catalog-viewer', {
    on: {
      "tableClicked": _vm.showTable
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('pane', {
    attrs: {
      "size": "70"
    }
  }, [_c('b-container', {
    staticClass: "m-0 p-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', [_c('splitpanes', {
    staticClass: "splitpanes",
    staticStyle: {
      "height": "260px"
    },
    attrs: {
      "vertical": ""
    }
  }, [_c('pane', {
    attrs: {
      "size": "70"
    }
  }, [(_vm.preferences.editor === 'classic') ? _c('b-form-textarea', {
    ref: "query",
    staticClass: "text-monospace",
    attrs: {
      "id": "query",
      "type": "text",
      "rows": "10",
      "no-resize": ""
    },
    on: {
      "change": _vm.onQueryChange
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.preferences.editor === 'new') ? _c('a-code-editor', {
    attrs: {
      "lineNumbers": ""
    },
    on: {
      "change": _vm.onQueryChange
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.preferences.showSavedQueries) ? _c('pane', {
    staticClass: "m-0 p-0",
    attrs: {
      "size": "30",
      "min-size": "10"
    }
  }, [_c('a-saved-queries', {
    attrs: {
      "username": "user"
    },
    on: {
      "copyQuery": _vm.onCopyQuery,
      "executeQuery": _vm.onExecuteSavedQuery
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [(_vm.tabs.length > 0) ? _c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('el-tabs', {
    staticClass: "mt-2",
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('el-tab-pane', {
      key: tab.id,
      staticClass: "p-1",
      scopedSlots: _vm._u([{
        key: "label",
        fn: function() {
          return [(tab.status !== 'Done') ? _c('b-spinner', {
            attrs: {
              "type": "border",
              "small": ""
            }
          }) : _vm._e(), _vm._v(" "), (tab.status === 'Done') ? _c('span', [(tab.type === 'table') ? _c('icon', {
            attrs: {
              "name": "table"
            }
          }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(tab.name))]), _vm._v(" \n\t\t\t\t\t\t\t\t\t\t"), _c('span', {
            on: {
              "click": function($event) {
                return _vm.deleteTab(tab.id)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "times"
            }
          })], 1)]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('b-card-text', [(tab.type === 'query') ? _c('a-query', {
      attrs: {
        "query": tab
      },
      on: {
        "onComplete": _vm.onComplete
      }
    }) : _vm._e(), _vm._v(" "), (tab.type === 'table') ? _c('a-table-info', {
      attrs: {
        "tab": tab
      },
      on: {
        "onComplete": _vm.onComplete
      }
    }) : _vm._e()], 1)], 1)
  }), 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21eedd02","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SQLWorkbenchPage.vue
// module id = 2139
// module chunks = 1